var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-11.5 -10.23174 23 20.46348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "React Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2.05,
    fill: "#61dafb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#61dafb",
    strokeWidth: 1,
    fill: "none"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 11,
    ry: 4.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 11,
    ry: 4.2,
    transform: "rotate(60)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 11,
    ry: 4.2,
    transform: "rotate(120)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactIcon);
export default __webpack_public_path__ + "static/media/React-icon.928f956d9c8ebcffb98a8e917154a81a.svg";
export { ForwardRef as ReactComponent };